import { Component, Input, Output, EventEmitter, HostListener } from "@angular/core";

@Component({
  selector: "toggle-form-sidebar",
  templateUrl: "./toggle-form-sidebar.component.html",
})
export class ToggleFormSidebarComponent {

  @Input() public formKey: string;
  @Output() public toggleFormSidebar: EventEmitter<boolean> = new EventEmitter();
  public isOpen: boolean = false;

  public toggleState() {
    this.isOpen = !this.isOpen;
    this.onToggle(false);
  }

  public initLeave() {
    return;
    const el = document.getElementById("col1");
    const elTrigger = el.firstElementChild;
    const btn = document.getElementById("serviceElements");
    if (el && elTrigger) {
      elTrigger.addEventListener("mouseleave", (event) => {
        el.classList.remove("shown");
        btn.classList.remove("shown");
      });
    }
  }

  @HostListener("window:keydown", ["$event"])
  @HostListener("window:mousedown", ["$event"])
  public clickToClose(event: any) {
    if (!event?.target?.classList.contains("builder-group-button")
      && !event?.target?.classList.contains("copyMoustach")
      && !event?.target?.classList.contains("copyComponent")
      && event?.target?.tagName !== 'INPUT'
      && !event?.target?.classList.contains("formcomponent")
      && !event?.target?.classList.contains("btn-label")) {
      const el = document.getElementById("col1");
      const btn = document.getElementById("serviceElements");
      if (el) {
        el.classList.remove("shown");
        btn.classList.remove("shown");
      }
    }
  }

  public onToggle(ignoreValue: boolean = false): void {
    const el = document.getElementById("col1");
    const btn = document.getElementById("serviceElements");
    if (el) {
      el.classList.add("shown");
      btn.classList.add("shown");
    }
    this.initLeave();
  }

  public openComponentsModal(): void {
    // Access the globally stored WebformBuilder instance
    const builderInstance = (window as any).formioBuilderInstance;
    if (builderInstance && typeof builderInstance.openComponentsModal === 'function') {
      builderInstance.openComponentsModal();
    } else {
      console.error('FormIO Builder instance not found or openComponentsModal method not available');
    }
  }

}
